import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { QuizQuestionAnswer } from '@digilize/shared/definitions/src';

@Component({
  selector: 'lsl-order-exercise',
  templateUrl: './order-exercise.component.html',
  styleUrls: ['./order-exercise.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OrderExerciseComponent implements OnInit {
  @Input() answerValidation: QuizQuestionAnswer;
  strings: string[];

  @Input() set answers(answers: QuizQuestionAnswer[]) {
    this.strings = answers.map((answer) => answer.text);
  }
  @Input() form: FormControl;
  _reset: boolean;
  @Input() set reset(value: boolean) {
    if (value) {
      this._reset = value;
      this.resetChange.emit(false);
    }
  }
  @Output() resetChange = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit() {}
}
